import { render } from "./fastDeal.vue?vue&type=template&id=dc8a66ec"
import script from "./fastDeal.vue?vue&type=script&lang=js"
export * from "./fastDeal.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins/workspace/staging-package-front-survey/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__